/* eslint-disable react-hooks/exhaustive-deps */
import * as yup from "yup";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import AutoComplete from "@/components/hookForms/autoComplete";
import TextInput from "@/components/hookForms/textField";
import messages from "@/utils/messages";
import { Title } from "@/components/title/style";
import serviceModeloFatura from "@/services/serviceModeloFatura";
import { LoadingButton } from "@mui/lab";
import { tipoCampoOptions } from "@/utils/constants";
import InputNumber from "@/components/hookForms/inputNumber";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    onClose?: any;
    data?: any;
    modeloDataOptions: any;
    descricaoFaturaValoresDataOptions: any;
}
const Modal: React.FC<IDialogProps> = ({
    open,
    onClose,
    data,
    onSuccess,
    modeloDataOptions,
    descricaoFaturaValoresDataOptions,
}) => {
    const [isDisable, setDisable] = useState(false);
    const [isComputedField, setComputedField] = useState(false);
    const [isReferenceField, setReferenceField] = useState(false);
    const [isXmlModel, setXmlModel] = useState(false);

    const validationSchema = yup.object().shape({
        descricaoFaturaValoresId: yup.number().typeError(messages.optionNotExist).required(messages.requiredField),
        modeloFaturaId: yup.number().typeError(messages.optionNotExist).required(messages.requiredField),
        posicao:
            isComputedField || (isXmlModel && isReferenceField)
                ? yup.string().notRequired().nullable()
                : yup
                      .string()
                      .matches(/^-?\d+$/, messages.requiredField)
                      .required(messages.requiredField),
        ocorrencia: isReferenceField
            ? yup
                  .string()
                  .matches(/^(?!0$)\d+$/, messages.requiredField)
                  .required(messages.requiredField)
            : yup.string().notRequired().nullable(),
        referencia: isReferenceField
            ? yup
                  .string()
                  .matches(/^\S.*$/, messages.requiredField)
                  .required(messages.requiredField)
            : yup.string().notRequired().nullable(),
        tipoCampo: yup.string().typeError(messages.optionNotExist).required(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        resetField,
        setValue,
        clearErrors,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            descricaoFaturaValoresId: "",
            modeloFaturaId: "",
            posicao: "",
            ocorrencia: "",
            referencia: "",
            tipoCampo: "",
        },
    });

    useEffect(() => {
        if (data) {
            const modelo = modeloDataOptions?.find((modelo) => modelo.modeloFaturaId === data.modeloFaturaId);

            modelo?.arquivoTipo === "xml" ? setXmlModel(true) : setXmlModel(false);

            data.tipoCampo === "C" ? setComputedField(true) : setComputedField(false);
            data.tipoCampo === "R" || data.tipoCampo === "H" ? setReferenceField(true) : setReferenceField(false);
            reset({ ...data, referencia: data.referencia ?? "", ocorrencia: data.ocorrencia ?? "1" });
        }
    }, [data]);

    const onSubmit = (values: any) => {
        setDisable(true);

        const newValues = {
            ...values,
            posicao: values.posicao ? Number(values.posicao.replaceAll(".", "").replaceAll(",", ".")) : null,
            ocorrencia: values.ocorrencia ? Number(values.ocorrencia.replaceAll(".", "").replaceAll(",", ".")) : 1,
        };

        serviceModeloFatura
            .updatePosicao(newValues)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    reset();
                    onClose();
                    onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setDisable(false);
            });
    };

    return (
        <Box>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    <Title>Editar Posição do Campo</Title>
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Grid container spacing={2}>
                            <Grid item md={12} xs={12}>
                                <AutoComplete
                                    id="modeloFaturaId"
                                    name="modeloFaturaId"
                                    label="Modelo"
                                    options={modeloDataOptions?.map((data) => {
                                        return { value: data.modeloFaturaId, label: data.descricaoModelo };
                                    })}
                                    control={control}
                                    error={errors}
                                    onChange={(value) => {
                                        const modelo = modeloDataOptions?.find(
                                            (modelo) => modelo.modeloFaturaId === value
                                        );

                                        if (modelo?.arquivoTipo === "xml") {
                                            setXmlModel(true);
                                            return;
                                        }
                                        setXmlModel(false);
                                        resetField("tipoCampo");
                                    }}
                                />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <AutoComplete
                                    id="descricaoFaturaValoresId"
                                    name="descricaoFaturaValoresId"
                                    label="Campo da Fatura"
                                    options={descricaoFaturaValoresDataOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <AutoComplete
                                    id="tipoCampo"
                                    name="tipoCampo"
                                    label="Tipo do Campo"
                                    options={isXmlModel ? tipoCampoOptions.slice(1) : tipoCampoOptions}
                                    control={control}
                                    error={errors}
                                    onChange={(value) => {
                                        if (value === "R" || value === "H") {
                                            setReferenceField(true);
                                            setComputedField(false);
                                            setValue("referencia", "");
                                            setValue("ocorrencia", "1");
                                            setValue("posicao", "");
                                            clearErrors();
                                            return;
                                        }
                                        if (value === "C") {
                                            setReferenceField(false);
                                            setComputedField(true);
                                            setValue("referencia", "");
                                            setValue("ocorrencia", "");
                                            setValue("posicao", "");
                                            clearErrors();
                                            return;
                                        }
                                        setReferenceField(false);
                                        setComputedField(false);
                                        setValue("posicao", "");
                                        setValue("ocorrencia", "");
                                        setValue("referencia", "");
                                        clearErrors();
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextInput
                                    id="referencia"
                                    name="referencia"
                                    label="Referência"
                                    control={control}
                                    error={errors}
                                    disabled={!isReferenceField}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <InputNumber
                                    id="ocorrencia"
                                    name="ocorrencia"
                                    label="Ocorrência"
                                    control={control}
                                    error={errors}
                                    disabled={!isReferenceField}
                                    decimalScale={0}
                                    noThousandSeparator={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <InputNumber
                                    id="posicao"
                                    name="posicao"
                                    label="Posição"
                                    control={control}
                                    error={errors}
                                    disabled={isComputedField}
                                    decimalScale={0}
                                    noThousandSeparator={true}
                                    allowNegative={true}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            onClick={() => {
                                reset();
                                onClose();
                            }}
                            color="warning"
                            variant="contained"
                            style={{ width: "159px", height: "44px" }}
                        >
                            Cancelar
                        </Button>
                        <LoadingButton
                            type="submit"
                            color="primary"
                            variant="contained"
                            disabled={isDisable}
                            loading={isDisable}
                            style={{ width: "159px", height: "44px" }}
                        >
                            Salvar
                        </LoadingButton>
                    </DialogActions>
                </form>
            </Dialog>
        </Box>
    );
};

export default Modal;
